// About Us — Pair Your Favourites landing page enhancer (2026-08-02, completed 2026-08-04)
// Targets: /pages/pair-your-favourites
//
// Injects 4 bundle panels (male/female toggle) with colour + size selectors and
// SHOP THE PAIR buttons. Each button uses Shopify /cart/add.js to pre-load both
// items (Native Trackpant + top). The $50-off-per-trackpant discount fires
// automatically at cart level (PR #882).
//
// Bundle pricing (after the automatic $50 cart discount):
//   TEE PAIR        : Native Trackpant + Oversized Signature Tee   → $135  (separately $185)
//   SWEATSHIRT PAIR : Native Trackpant + Elements Sweatshirt        → $170  (separately $220)
//   ELEMENTS HOODIE : Native Trackpant + Elements Hoodie            → $190  (hero, separately $240)
//   NATIVE HOODIE   : Native Trackpant + Native Hoodie              → $210  (separately $260)
//
// Variant IDs are resolved from a static map (verified against the live Shopify
// catalogue on 2026-08-04) rather than fetched per-handle — the earlier draft
// used a wrong trackpant handle that 404'd. Sizes offered: S M L XL (the Native
// Trackpant has no XS, so the pair is capped to the sizes both pieces share).
//
// BRAND GUARDRAIL: no urgency language. CTA is "SHOP THE PAIR" only. Set pricing
// is shown as "separately $X" — never as a saving.
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (!/\/pages\/pair-your-favourites/i.test(location.pathname)) return;
  if (window.__auPairLoaded) return;
  window.__auPairLoaded = true;

  var BRAND_NAVY = '#131936';
  var BRAND_MILK = '#F4F1EA';
  var FONT_BODY = "'Raleway', 'Helvetica Neue', sans-serif";
  var FONT_DISPLAY = "'Unbounded', 'Helvetica Neue', sans-serif";
  var CDN = 'https://tmohtgpckynjdrnfjomm.supabase.co/storage/v1/object/public/campaign-assets/pair-your-favourites/';

  // (product, colour, size) -> Shopify variant id.
  var VARIANTS = {
    trackpant: {
      'Chalk': { S: 41425248682069, M: 41425248714837, L: 41425248747605, XL: 41425248780373 },
      'Ink':   { S: 41425248813141, M: 41425248845909, L: 41425248878677, XL: 41425248911445 }
    },
    tee: { // Oversized Signature Logo Tee
      'White': { S: 41985020788821, M: 41985020854357, L: 41985020657749, XL: 41985020919893 },
      'Black': { S: 41985020821589, M: 41985020887125, L: 41985020690517, XL: 41985020952661 }
    },
    sweatshirt: { // Elements Sweatshirt
      'Ivory':         { S: 41425241342037, M: 41425241374805, L: 41425241407573, XL: 41425241440341 },
      'Caspian Green': { S: 41425242161237, M: 41425242194005, L: 41425242226773, XL: 41425242259541 },
      'Forest Green':  { S: 41635786719317, M: 41635786752085, L: 41635786784853, XL: 41635786817621 }
    },
    elementsHoodie: {
      'Ivory':         { S: 41424422404181, M: 41424422436949, L: 41424422469717, XL: 41424422502485 },
      'Caspian Green': { S: 41425236951125, M: 41425236983893, L: 41425237016661, XL: 41425237049429 },
      'Clay':          { S: 41425238818901, M: 41425238851669, L: 41425238884437, XL: 41425238917205 },
      'Forest Green':  { S: 41635774333013, M: 41635774365781, L: 41635774398549, XL: 41635774431317 }
    },
    nativeHoodie: {
      'Chalk': { S: 41425248354389, M: 41425248387157, L: 41425248419925, XL: 41425248452693 },
      'Ink':   { S: 41425248518229, M: 41425248550997, L: 41425248583765, XL: 41425248616533 }
    }
  };

  var SIZES = ['S', 'M', 'L', 'XL'];

  // Four bundles. Each renders one panel with a male/female image toggle (P#/F#).
  var BUNDLES = [
    {
      id: 'tee', label: 'THE TEE PAIR', price: '$135', separately: '$185',
      description: 'Native Trackpant + Oversized Signature Tee',
      pantColours: ['Chalk', 'Ink'], pantDefault: 'Chalk',
      top: 'tee', topLabel: 'Tee', topColours: ['White', 'Black'], topDefault: 'White',
      imageMale: CDN + 'P1-tee-4x5.png', imageFemale: CDN + 'F1-tee-4x5.png'
    },
    {
      id: 'sweatshirt', label: 'THE SWEATSHIRT PAIR', price: '$170', separately: '$220',
      description: 'Native Trackpant + Elements Sweatshirt',
      pantColours: ['Chalk', 'Ink'], pantDefault: 'Chalk',
      top: 'sweatshirt', topLabel: 'Sweatshirt', topColours: ['Ivory', 'Caspian Green', 'Forest Green'], topDefault: 'Ivory',
      imageMale: CDN + 'P2-sweatshirt-4x5.png', imageFemale: CDN + 'F2-sweatshirt-4x5.png'
    },
    {
      id: 'elements-hoodie', label: 'THE ELEMENTS HOODIE PAIR', price: '$190', separately: '$240',
      description: 'Native Trackpant + Elements Hoodie',
      pantColours: ['Chalk', 'Ink'], pantDefault: 'Ink',
      top: 'elementsHoodie', topLabel: 'Elements Hoodie', topColours: ['Ivory', 'Caspian Green', 'Clay', 'Forest Green'], topDefault: 'Ivory',
      imageMale: CDN + 'P3-hero-elements-4x5.png', imageFemale: CDN + 'F3-hero-elements-4x5.png',
      isHero: true
    },
    {
      id: 'native-hoodie', label: 'THE NATIVE HOODIE PAIR', price: '$210', separately: '$260',
      description: 'Native Trackpant + Native Hoodie',
      pantColours: ['Chalk', 'Ink'], pantDefault: 'Ink',
      top: 'nativeHoodie', topLabel: 'Native Hoodie', topColours: ['Chalk', 'Ink'], topDefault: 'Ink',
      imageMale: CDN + 'P4-native-4x5.png', imageFemale: CDN + 'F4-native-4x5.png'
    }
  ];

  function variantId(product, colour, size) {
    var p = VARIANTS[product]; if (!p) return null;
    var c = p[colour] || p[Object.keys(p)[0]];
    return (c && (c[size] || c.M)) || null;
  }

  var style = document.createElement('style');
  style.textContent = [
    '.au-pyf-section{font-family:' + FONT_BODY + ';max-width:1200px;margin:0 auto;padding:40px 20px;}',
    '.au-pyf-hero{text-align:center;margin-bottom:56px;}',
    '.au-pyf-hero h1{font-family:' + FONT_DISPLAY + ';font-size:clamp(28px,5vw,48px);font-weight:900;',
    '  letter-spacing:-0.02em;color:' + BRAND_NAVY + ';text-transform:uppercase;margin:0 0 16px;}',
    '.au-pyf-hero p{font-size:16px;color:rgba(19,25,54,0.65);max-width:560px;margin:0 auto;}',
    '.au-pyf-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:40px;}',
    '.au-pyf-panel{display:flex;flex-direction:column;}',
    '.au-pyf-panel.is-hero{grid-column:span 2;}',
    '@media(max-width:680px){.au-pyf-panel.is-hero{grid-column:span 1;}}',
    '.au-pyf-img-wrap{position:relative;aspect-ratio:4/5;background:rgba(19,25,54,0.06);',
    '  border-radius:4px;overflow:hidden;margin-bottom:16px;}',
    '.au-pyf-img-wrap img{width:100%;height:100%;object-fit:cover;object-position:center top;}',
    '.au-pyf-flag{position:absolute;top:12px;left:12px;background:' + BRAND_MILK + ';color:' + BRAND_NAVY + ';',
    '  font-size:10px;letter-spacing:0.12em;text-transform:uppercase;font-weight:700;padding:5px 11px;border-radius:2px;}',
    '.au-pyf-gender-toggle{display:flex;gap:0;border:1px solid rgba(19,25,54,0.15);border-radius:3px;',
    '  align-self:flex-start;margin-bottom:14px;overflow:hidden;}',
    '.au-pyf-gender-toggle button{padding:6px 14px;font-size:11px;font-family:' + FONT_BODY + ';',
    '  font-weight:600;letter-spacing:0.06em;text-transform:uppercase;border:none;cursor:pointer;',
    '  background:transparent;color:rgba(19,25,54,0.5);transition:all 0.15s;}',
    '.au-pyf-gender-toggle button.active{background:' + BRAND_NAVY + ';color:' + BRAND_MILK + ';}',
    '.au-pyf-label{font-family:' + FONT_DISPLAY + ';font-size:12px;font-weight:700;',
    '  letter-spacing:0.08em;text-transform:uppercase;color:' + BRAND_NAVY + ';margin-bottom:6px;}',
    '.au-pyf-desc{font-size:14px;color:rgba(19,25,54,0.65);margin-bottom:4px;}',
    '.au-pyf-price{font-size:20px;font-weight:700;color:' + BRAND_NAVY + ';margin-bottom:2px;}',
    '.au-pyf-sep{font-size:12px;color:rgba(19,25,54,0.45);margin-bottom:16px;}',
    '.au-pyf-fields{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:16px;}',
    '.au-pyf-field{flex:1;min-width:110px;}',
    '.au-pyf-field label{display:block;font-size:11px;font-weight:600;letter-spacing:0.07em;',
    '  text-transform:uppercase;color:rgba(19,25,54,0.5);margin-bottom:6px;}',
    '.au-pyf-field select{width:100%;padding:9px 10px;border:1px solid rgba(19,25,54,0.2);',
    '  border-radius:3px;font-family:' + FONT_BODY + ';font-size:13px;color:' + BRAND_NAVY + ';',
    '  background:#fff;appearance:none;-webkit-appearance:none;cursor:pointer;}',
    '.au-pyf-cta{display:block;width:100%;padding:13px 30px;background:' + BRAND_NAVY + ';',
    '  color:' + BRAND_MILK + ';font-family:' + FONT_BODY + ';font-size:13px;font-weight:500;',
    '  letter-spacing:0.08em;text-transform:uppercase;border:none;cursor:pointer;',
    '  transition:opacity 0.15s;text-align:center;}',
    '.au-pyf-cta:hover{opacity:0.88;}',
    '.au-pyf-cta.adding{opacity:0.6;pointer-events:none;}',
    '.au-pyf-msg{font-size:12px;margin-top:8px;min-height:18px;color:rgba(19,25,54,0.55);}',
    '.au-pyf-msg.error{color:#b00;}',
    '.au-pyf-note{text-align:center;font-size:12px;color:rgba(19,25,54,0.45);margin-top:48px;',
    '  padding-top:24px;border-top:1px solid rgba(19,25,54,0.1);}'
  ].join('\n');
  document.head.appendChild(style);

  function selectField(id, label, options, selected) {
    var wrap = document.createElement('div');
    wrap.className = 'au-pyf-field';
    var lbl = document.createElement('label');
    lbl.textContent = label; lbl.htmlFor = id;
    var sel = document.createElement('select');
    sel.id = id;
    options.forEach(function (o) {
      var opt = document.createElement('option');
      opt.value = o; opt.textContent = o;
      if (o === selected) opt.selected = true;
      sel.appendChild(opt);
    });
    wrap.appendChild(lbl); wrap.appendChild(sel);
    return wrap;
  }

  function renderPanel(bundle, container) {
    var panel = document.createElement('div');
    panel.className = 'au-pyf-panel' + (bundle.isHero ? ' is-hero' : '');

    var imgWrap = document.createElement('div');
    imgWrap.className = 'au-pyf-img-wrap';
    if (bundle.isHero) {
      var flag = document.createElement('div');
      flag.className = 'au-pyf-flag';
      flag.textContent = 'The Hero Pair';
      imgWrap.appendChild(flag);
    }
    var imgEl = document.createElement('img');
    imgEl.alt = bundle.label;
    imgEl.loading = 'lazy';
    imgEl.src = bundle.imageMale;
    imgWrap.appendChild(imgEl);
    panel.appendChild(imgWrap);

    var currentGender = 'male';
    var toggle = document.createElement('div');
    toggle.className = 'au-pyf-gender-toggle';
    ['Male', 'Female'].forEach(function (g) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = g;
      if (g.toLowerCase() === currentGender) btn.className = 'active';
      btn.addEventListener('click', function () {
        currentGender = g.toLowerCase();
        toggle.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        imgEl.src = currentGender === 'female' ? bundle.imageFemale : bundle.imageMale;
      });
      toggle.appendChild(btn);
    });
    panel.appendChild(toggle);

    var labelEl = document.createElement('div');
    labelEl.className = 'au-pyf-label'; labelEl.textContent = bundle.label;
    panel.appendChild(labelEl);

    var descEl = document.createElement('div');
    descEl.className = 'au-pyf-desc'; descEl.textContent = bundle.description;
    panel.appendChild(descEl);

    var priceEl = document.createElement('div');
    priceEl.className = 'au-pyf-price'; priceEl.textContent = bundle.price;
    panel.appendChild(priceEl);

    var sepEl = document.createElement('div');
    sepEl.className = 'au-pyf-sep'; sepEl.textContent = 'Separately ' + bundle.separately;
    panel.appendChild(sepEl);

    var fields = document.createElement('div');
    fields.className = 'au-pyf-fields';
    var pantSel = selectField('pant-c-' + bundle.id, 'Trackpant', bundle.pantColours, bundle.pantDefault);
    var topSel = selectField('top-c-' + bundle.id, bundle.topLabel, bundle.topColours, bundle.topDefault);
    var sizeSel = selectField('size-' + bundle.id, 'Size', SIZES, 'M');
    fields.appendChild(pantSel); fields.appendChild(topSel); fields.appendChild(sizeSel);
    panel.appendChild(fields);

    var ctaBtn = document.createElement('button');
    ctaBtn.type = 'button';
    ctaBtn.className = 'au-pyf-cta';
    ctaBtn.textContent = 'SHOP THE PAIR';
    panel.appendChild(ctaBtn);

    var msgEl = document.createElement('div');
    msgEl.className = 'au-pyf-msg';
    panel.appendChild(msgEl);

    ctaBtn.addEventListener('click', function () {
      var pantColour = pantSel.querySelector('select').value;
      var topColour = topSel.querySelector('select').value;
      var size = sizeSel.querySelector('select').value;
      var pantId = variantId('trackpant', pantColour, size);
      var topId = variantId(bundle.top, topColour, size);
      if (!pantId || !topId) {
        msgEl.textContent = 'That combination is unavailable — try another size.';
        msgEl.className = 'au-pyf-msg error';
        return;
      }
      ctaBtn.classList.add('adding');
      ctaBtn.textContent = 'Adding…';
      msgEl.textContent = ''; msgEl.className = 'au-pyf-msg';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: pantId, quantity: 1 }, { id: topId, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
          return r.json();
        })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) {
          ctaBtn.classList.remove('adding');
          ctaBtn.textContent = 'SHOP THE PAIR';
          msgEl.textContent = err.message || 'Something went wrong — please try again.';
          msgEl.className = 'au-pyf-msg error';
        });
    });

    container.appendChild(panel);
  }

  function injectLandingPage() {
    var contentEl = document.querySelector('.page-width main, .main-page-content, #MainContent, main');
    if (!contentEl) return;

    var section = document.createElement('div');
    section.className = 'au-pyf-section';

    var hero = document.createElement('div');
    hero.className = 'au-pyf-hero';
    hero.innerHTML = [
      '<h1>Pair Your Favourites</h1>',
      '<p>Native Trackpant + your favourite top. Four ways to wear it.</p>'
    ].join('');
    section.appendChild(hero);

    var grid = document.createElement('div');
    grid.className = 'au-pyf-grid';
    section.appendChild(grid);

    BUNDLES.forEach(function (b) { renderPanel(b, grid); });

    var note = document.createElement('div');
    note.className = 'au-pyf-note';
    note.textContent = 'The pair price applies automatically at cart. Set pricing, not a saving — how it was meant to be worn.';
    section.appendChild(note);

    var existing = contentEl.firstChild;
    if (existing) { contentEl.insertBefore(section, existing); } else { contentEl.appendChild(section); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectLandingPage);
  } else {
    injectLandingPage();
  }
}());
